import { ENVS, prHostRegex } from "./config";

export const HOSTNAME = {
  PROD: "console.cloud.tigerdata.com",
  /**
   * Old Prod hostname. Kept here for
   * backwards compatibility.
   */
  OLD_PROD: "console.cloud.timescale.com",
  /**
   * The hostname for the local Prod environment,
   * like when running `yarn start:prod-api`.
   */
  PROD_LOCAL: "local.cloud.tigerdata.com",
  DEV: "console.dev.tigerdata.com",
} as const;

//needs to be separate from rest of ./config b/c "window" object disrupts nodejs functions
export const ENV = (() => {
  const host = window.location.hostname;
  switch (host) {
    case HOSTNAME.OLD_PROD:
    case HOSTNAME.PROD:
    case HOSTNAME.PROD_LOCAL:
      return ENVS["production"];
    case HOSTNAME.DEV:
      return ENVS["development"];
    default:
      // PR instances should use development config
      // e.g. https://savannah-tiger-cloud-pr-4480.onrender.com
      if (host && prHostRegex.test(host)) return ENVS["development"];
      return ENVS["local"];
  }
})();
